module.exports = __webpack_public_path__ + "img/service.a2d01227.svg";